import React from "react";
import { Backdrop, Box, Chip, CircularProgress, Stack, Typography } from "@mui/material";

type CreationProgressModalProps = {
  open: boolean;
  storeLabel: string;
  title: string;
  description: string;
};

const CreationProgressModal: React.FC<CreationProgressModalProps> = ({
  open,
  storeLabel,
  title,
  description,
}) => {
  return (
    <Backdrop
      open={open}
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 10,
        backdropFilter: "blur(4px)",
      }}
    >
      <Box
        sx={{
          width: "min(560px, 92vw)",
          borderRadius: 4,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          color: "text.primary",
          p: { xs: 2.5, md: 3 },
          boxShadow: 12,
        }}
      >
        <Stack spacing={1.5}>
          <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap">
            <Chip size="small" color="primary" label={storeLabel} />
            <Chip size="small" color="success" variant="outlined" label="In Progress" />
          </Stack>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <CircularProgress size={22} />
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              {title}
            </Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Stack>
      </Box>
    </Backdrop>
  );
};

export default CreationProgressModal;
